/* eslint-disable eag/match-named-export */
export const COUNTRY_CZE = 'CZE';

export const DEFAULT_COUNTRY = COUNTRY_CZE;
